/**
 * Stamped by image renderers (both ad engines) on elements that display
 * AI-generated imagery. The watermark overlay watches for it in the DOM,
 * which is the one place both engines converge.
 */
export const AI_GENERATED_ATTRIBUTE = 'data-ai-generated'

export const AI_GENERATED_LABEL_URL = '/ai-generated-label.png'
